import { useSelectRealUser } from "@shared/utils/hooks/misc.ts";
import React, { useEffect, useState } from "react";
import NoExchangeConnectedModal from "features/configuration/common/NoExchangeConnectedModal.tsx";

const SubUserNoClientsModal = () => {
  const user = useSelectRealUser();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (user && user?.is_sub_user && !user?.has_non_deleted_clients_connected) {
      setModalOpen(true);
    }
  }, [user]);

  return (
    <NoExchangeConnectedModal
      placement="sub_user"
      open={modalOpen}
      onClose={() => setModalOpen(false)}
    />
  );
};

export default SubUserNoClientsModal;
